import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PopoverModule } from 'ngx-bootstrap/popover';

@Component({
  selector: 'app-admin-supplier-interface-tag',
  standalone: true,
  imports: [CommonModule, PopoverModule],
  templateUrl: './admin-supplier-interface-tag.component.html',
  styleUrl: './admin-supplier-interface-tag.component.scss'
})
export class AdminSupplierInterfaceTagComponent {
  @Input() tag: string = '';
  @Input() theme: string = '';
  @Input() data: string[];
}
